/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/root'
import { Route as homeRouteImport } from './routes/home'
import { Route as appLayoutRouteImport } from './routes/app/layout'
import { Route as authLayoutRouteImport } from './routes/auth/layout'
import { Route as onboardingLayoutRouteImport } from './routes/onboarding/layout'
import { Route as connectorSetupRouteImport } from './routes/connector-setup'
import { Route as appExperimentsRouteImport } from './routes/app/experiments'
import { Route as appKlevRouteImport } from './routes/app/klev'
import { Route as appOverviewRouteImport } from './routes/app/overview'
import { Route as appReportsRouteImport } from './routes/app/reports'
import { Route as appSalesRouteImport } from './routes/app/sales'
import { Route as appSettingsLayoutRouteImport } from './routes/app/settings/layout'
import { Route as authForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as authResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as authSignInRouteImport } from './routes/auth/sign-in'
import { Route as authSignUpRouteImport } from './routes/auth/sign-up'
import { Route as authVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as onboardingDataLoadingRouteImport } from './routes/onboarding/data-loading'
import { Route as appAttributionIndexRouteImport } from './routes/app/attribution/index'
import { Route as appAttributionDetailRouteImport } from './routes/app/attribution/detail'
import { Route as appAttributionOrderRouteImport } from './routes/app/attribution/order'
import { Route as appCreativeIndexRouteImport } from './routes/app/creative/index'
import { Route as appCreativeCompetitorsRouteImport } from './routes/app/creative/competitors'
import { Route as appSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as appSettingsBillingRouteImport } from './routes/app/settings/billing'
import { Route as appSettingsCreditsRouteImport } from './routes/app/settings/credits'
import { Route as appSettingsIntegrationsRouteImport } from './routes/app/settings/integrations'
import { Route as appSettingsSkillsRouteImport } from './routes/app/settings/skills'
import { Route as appSettingsUtmRouteImport } from './routes/app/settings/utm'
import { Route as onboardingAboutCompanyRouteImport } from './routes/onboarding/about-company'
import { Route as onboardingAiVisibilityRouteImport } from './routes/onboarding/ai-visibility'
import { Route as onboardingBusinessDnaRouteImport } from './routes/onboarding/business-dna'
import { Route as onboardingConnectDataRouteImport } from './routes/onboarding/connect-data'
import { Route as onboardingPersonalizationRouteImport } from './routes/onboarding/personalization'
import { Route as onboardingReferralCodeRouteImport } from './routes/onboarding/referral-code'

const homeRoute = homeRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const appLayoutRoute = appLayoutRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const authLayoutRoute = authLayoutRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const onboardingLayoutRoute = onboardingLayoutRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const connectorSetupRoute = connectorSetupRouteImport.update({
  id: '/connector-setup',
  path: '/connector-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const appExperimentsRoute = appExperimentsRouteImport.update({
  id: '/experiments',
  path: '/experiments',
  getParentRoute: () => appLayoutRoute,
} as any)
const appKlevRoute = appKlevRouteImport.update({
  id: '/klev',
  path: '/klev',
  getParentRoute: () => appLayoutRoute,
} as any)
const appOverviewRoute = appOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => appLayoutRoute,
} as any)
const appReportsRoute = appReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => appLayoutRoute,
} as any)
const appSalesRoute = appSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => appLayoutRoute,
} as any)
const appSettingsLayoutRoute = appSettingsLayoutRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appLayoutRoute,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authLayoutRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authLayoutRoute,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authLayoutRoute,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => authLayoutRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => authLayoutRoute,
} as any)
const onboardingDataLoadingRoute = onboardingDataLoadingRouteImport.update({
  id: '/onboarding/data-loading',
  path: '/onboarding/data-loading',
  getParentRoute: () => rootRouteImport,
} as any)
const appAttributionIndexRoute = appAttributionIndexRouteImport.update({
  id: '/attribution/',
  path: '/attribution/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appAttributionDetailRoute = appAttributionDetailRouteImport.update({
  id: '/attribution/detail',
  path: '/attribution/detail',
  getParentRoute: () => appLayoutRoute,
} as any)
const appAttributionOrderRoute = appAttributionOrderRouteImport.update({
  id: '/attribution/order',
  path: '/attribution/order',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCreativeIndexRoute = appCreativeIndexRouteImport.update({
  id: '/creative/',
  path: '/creative/',
  getParentRoute: () => appLayoutRoute,
} as any)
const appCreativeCompetitorsRoute = appCreativeCompetitorsRouteImport.update({
  id: '/creative/competitors',
  path: '/creative/competitors',
  getParentRoute: () => appLayoutRoute,
} as any)
const appSettingsIndexRoute = appSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appSettingsLayoutRoute,
} as any)
const appSettingsBillingRoute = appSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => appSettingsLayoutRoute,
} as any)
const appSettingsCreditsRoute = appSettingsCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => appSettingsLayoutRoute,
} as any)
const appSettingsIntegrationsRoute = appSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => appSettingsLayoutRoute,
} as any)
const appSettingsSkillsRoute = appSettingsSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => appSettingsLayoutRoute,
} as any)
const appSettingsUtmRoute = appSettingsUtmRouteImport.update({
  id: '/utm',
  path: '/utm',
  getParentRoute: () => appSettingsLayoutRoute,
} as any)
const onboardingAboutCompanyRoute = onboardingAboutCompanyRouteImport.update({
  id: '/onboarding/about-company',
  path: '/onboarding/about-company',
  getParentRoute: () => onboardingLayoutRoute,
} as any)
const onboardingAiVisibilityRoute = onboardingAiVisibilityRouteImport.update({
  id: '/onboarding/ai-visibility',
  path: '/onboarding/ai-visibility',
  getParentRoute: () => onboardingLayoutRoute,
} as any)
const onboardingBusinessDnaRoute = onboardingBusinessDnaRouteImport.update({
  id: '/onboarding/business-dna',
  path: '/onboarding/business-dna',
  getParentRoute: () => onboardingLayoutRoute,
} as any)
const onboardingConnectDataRoute = onboardingConnectDataRouteImport.update({
  id: '/onboarding/connect-data',
  path: '/onboarding/connect-data',
  getParentRoute: () => onboardingLayoutRoute,
} as any)
const onboardingPersonalizationRoute =
  onboardingPersonalizationRouteImport.update({
    id: '/onboarding/personalization',
    path: '/onboarding/personalization',
    getParentRoute: () => onboardingLayoutRoute,
  } as any)
const onboardingReferralCodeRoute = onboardingReferralCodeRouteImport.update({
  id: '/onboarding/referral-code',
  path: '/onboarding/referral-code',
  getParentRoute: () => onboardingLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof homeRoute
  '/connector-setup': typeof connectorSetupRoute
  '/experiments': typeof appExperimentsRoute
  '/klev': typeof appKlevRoute
  '/overview': typeof appOverviewRoute
  '/reports': typeof appReportsRoute
  '/sales': typeof appSalesRoute
  '/settings': typeof appSettingsLayoutRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/onboarding/data-loading': typeof onboardingDataLoadingRoute
  '/attribution/detail': typeof appAttributionDetailRoute
  '/attribution/order': typeof appAttributionOrderRoute
  '/creative/competitors': typeof appCreativeCompetitorsRoute
  '/settings/billing': typeof appSettingsBillingRoute
  '/settings/credits': typeof appSettingsCreditsRoute
  '/settings/integrations': typeof appSettingsIntegrationsRoute
  '/settings/skills': typeof appSettingsSkillsRoute
  '/settings/utm': typeof appSettingsUtmRoute
  '/onboarding/about-company': typeof onboardingAboutCompanyRoute
  '/onboarding/ai-visibility': typeof onboardingAiVisibilityRoute
  '/onboarding/business-dna': typeof onboardingBusinessDnaRoute
  '/onboarding/connect-data': typeof onboardingConnectDataRoute
  '/onboarding/personalization': typeof onboardingPersonalizationRoute
  '/onboarding/referral-code': typeof onboardingReferralCodeRoute
  '/attribution/': typeof appAttributionIndexRoute
  '/creative/': typeof appCreativeIndexRoute
  '/settings/': typeof appSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof homeRoute
  '/connector-setup': typeof connectorSetupRoute
  '/experiments': typeof appExperimentsRoute
  '/klev': typeof appKlevRoute
  '/overview': typeof appOverviewRoute
  '/reports': typeof appReportsRoute
  '/sales': typeof appSalesRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/onboarding/data-loading': typeof onboardingDataLoadingRoute
  '/attribution/detail': typeof appAttributionDetailRoute
  '/attribution/order': typeof appAttributionOrderRoute
  '/creative/competitors': typeof appCreativeCompetitorsRoute
  '/settings/billing': typeof appSettingsBillingRoute
  '/settings/credits': typeof appSettingsCreditsRoute
  '/settings/integrations': typeof appSettingsIntegrationsRoute
  '/settings/skills': typeof appSettingsSkillsRoute
  '/settings/utm': typeof appSettingsUtmRoute
  '/onboarding/about-company': typeof onboardingAboutCompanyRoute
  '/onboarding/ai-visibility': typeof onboardingAiVisibilityRoute
  '/onboarding/business-dna': typeof onboardingBusinessDnaRoute
  '/onboarding/connect-data': typeof onboardingConnectDataRoute
  '/onboarding/personalization': typeof onboardingPersonalizationRoute
  '/onboarding/referral-code': typeof onboardingReferralCodeRoute
  '/attribution': typeof appAttributionIndexRoute
  '/creative': typeof appCreativeIndexRoute
  '/settings': typeof appSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof homeRoute
  '/_app': typeof appLayoutRouteWithChildren
  '/_auth': typeof authLayoutRouteWithChildren
  '/_onboarding': typeof onboardingLayoutRouteWithChildren
  '/connector-setup': typeof connectorSetupRoute
  '/_app/experiments': typeof appExperimentsRoute
  '/_app/klev': typeof appKlevRoute
  '/_app/overview': typeof appOverviewRoute
  '/_app/reports': typeof appReportsRoute
  '/_app/sales': typeof appSalesRoute
  '/_app/settings': typeof appSettingsLayoutRouteWithChildren
  '/_auth/forgot-password': typeof authForgotPasswordRoute
  '/_auth/reset-password': typeof authResetPasswordRoute
  '/_auth/sign-in': typeof authSignInRoute
  '/_auth/sign-up': typeof authSignUpRoute
  '/_auth/verify-email': typeof authVerifyEmailRoute
  '/onboarding/data-loading': typeof onboardingDataLoadingRoute
  '/_app/attribution/detail': typeof appAttributionDetailRoute
  '/_app/attribution/order': typeof appAttributionOrderRoute
  '/_app/creative/competitors': typeof appCreativeCompetitorsRoute
  '/_app/settings/billing': typeof appSettingsBillingRoute
  '/_app/settings/credits': typeof appSettingsCreditsRoute
  '/_app/settings/integrations': typeof appSettingsIntegrationsRoute
  '/_app/settings/skills': typeof appSettingsSkillsRoute
  '/_app/settings/utm': typeof appSettingsUtmRoute
  '/_onboarding/onboarding/about-company': typeof onboardingAboutCompanyRoute
  '/_onboarding/onboarding/ai-visibility': typeof onboardingAiVisibilityRoute
  '/_onboarding/onboarding/business-dna': typeof onboardingBusinessDnaRoute
  '/_onboarding/onboarding/connect-data': typeof onboardingConnectDataRoute
  '/_onboarding/onboarding/personalization': typeof onboardingPersonalizationRoute
  '/_onboarding/onboarding/referral-code': typeof onboardingReferralCodeRoute
  '/_app/attribution/': typeof appAttributionIndexRoute
  '/_app/creative/': typeof appCreativeIndexRoute
  '/_app/settings/': typeof appSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connector-setup'
    | '/experiments'
    | '/klev'
    | '/overview'
    | '/reports'
    | '/sales'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/onboarding/data-loading'
    | '/attribution/detail'
    | '/attribution/order'
    | '/creative/competitors'
    | '/settings/billing'
    | '/settings/credits'
    | '/settings/integrations'
    | '/settings/skills'
    | '/settings/utm'
    | '/onboarding/about-company'
    | '/onboarding/ai-visibility'
    | '/onboarding/business-dna'
    | '/onboarding/connect-data'
    | '/onboarding/personalization'
    | '/onboarding/referral-code'
    | '/attribution/'
    | '/creative/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connector-setup'
    | '/experiments'
    | '/klev'
    | '/overview'
    | '/reports'
    | '/sales'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/onboarding/data-loading'
    | '/attribution/detail'
    | '/attribution/order'
    | '/creative/competitors'
    | '/settings/billing'
    | '/settings/credits'
    | '/settings/integrations'
    | '/settings/skills'
    | '/settings/utm'
    | '/onboarding/about-company'
    | '/onboarding/ai-visibility'
    | '/onboarding/business-dna'
    | '/onboarding/connect-data'
    | '/onboarding/personalization'
    | '/onboarding/referral-code'
    | '/attribution'
    | '/creative'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_onboarding'
    | '/connector-setup'
    | '/_app/experiments'
    | '/_app/klev'
    | '/_app/overview'
    | '/_app/reports'
    | '/_app/sales'
    | '/_app/settings'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/verify-email'
    | '/onboarding/data-loading'
    | '/_app/attribution/detail'
    | '/_app/attribution/order'
    | '/_app/creative/competitors'
    | '/_app/settings/billing'
    | '/_app/settings/credits'
    | '/_app/settings/integrations'
    | '/_app/settings/skills'
    | '/_app/settings/utm'
    | '/_onboarding/onboarding/about-company'
    | '/_onboarding/onboarding/ai-visibility'
    | '/_onboarding/onboarding/business-dna'
    | '/_onboarding/onboarding/connect-data'
    | '/_onboarding/onboarding/personalization'
    | '/_onboarding/onboarding/referral-code'
    | '/_app/attribution/'
    | '/_app/creative/'
    | '/_app/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  homeRoute: typeof homeRoute
  appLayoutRoute: typeof appLayoutRouteWithChildren
  authLayoutRoute: typeof authLayoutRouteWithChildren
  onboardingLayoutRoute: typeof onboardingLayoutRouteWithChildren
  connectorSetupRoute: typeof connectorSetupRoute
  onboardingDataLoadingRoute: typeof onboardingDataLoadingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof homeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof appLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof authLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof onboardingLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connector-setup': {
      id: '/connector-setup'
      path: '/connector-setup'
      fullPath: '/connector-setup'
      preLoaderRoute: typeof connectorSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/experiments': {
      id: '/_app/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof appExperimentsRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/klev': {
      id: '/_app/klev'
      path: '/klev'
      fullPath: '/klev'
      preLoaderRoute: typeof appKlevRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/overview': {
      id: '/_app/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof appOverviewRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof appReportsRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/sales': {
      id: '/_app/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof appSalesRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appSettingsLayoutRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authLayoutRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authLayoutRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authLayoutRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof authLayoutRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authLayoutRoute
    }
    '/onboarding/data-loading': {
      id: '/onboarding/data-loading'
      path: '/onboarding/data-loading'
      fullPath: '/onboarding/data-loading'
      preLoaderRoute: typeof onboardingDataLoadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/attribution/': {
      id: '/_app/attribution/'
      path: '/attribution'
      fullPath: '/attribution/'
      preLoaderRoute: typeof appAttributionIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/attribution/detail': {
      id: '/_app/attribution/detail'
      path: '/attribution/detail'
      fullPath: '/attribution/detail'
      preLoaderRoute: typeof appAttributionDetailRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/attribution/order': {
      id: '/_app/attribution/order'
      path: '/attribution/order'
      fullPath: '/attribution/order'
      preLoaderRoute: typeof appAttributionOrderRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/creative/': {
      id: '/_app/creative/'
      path: '/creative'
      fullPath: '/creative/'
      preLoaderRoute: typeof appCreativeIndexRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/creative/competitors': {
      id: '/_app/creative/competitors'
      path: '/creative/competitors'
      fullPath: '/creative/competitors'
      preLoaderRoute: typeof appCreativeCompetitorsRouteImport
      parentRoute: typeof appLayoutRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof appSettingsIndexRouteImport
      parentRoute: typeof appSettingsLayoutRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof appSettingsBillingRouteImport
      parentRoute: typeof appSettingsLayoutRoute
    }
    '/_app/settings/credits': {
      id: '/_app/settings/credits'
      path: '/credits'
      fullPath: '/settings/credits'
      preLoaderRoute: typeof appSettingsCreditsRouteImport
      parentRoute: typeof appSettingsLayoutRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof appSettingsIntegrationsRouteImport
      parentRoute: typeof appSettingsLayoutRoute
    }
    '/_app/settings/skills': {
      id: '/_app/settings/skills'
      path: '/skills'
      fullPath: '/settings/skills'
      preLoaderRoute: typeof appSettingsSkillsRouteImport
      parentRoute: typeof appSettingsLayoutRoute
    }
    '/_app/settings/utm': {
      id: '/_app/settings/utm'
      path: '/utm'
      fullPath: '/settings/utm'
      preLoaderRoute: typeof appSettingsUtmRouteImport
      parentRoute: typeof appSettingsLayoutRoute
    }
    '/_onboarding/onboarding/about-company': {
      id: '/_onboarding/onboarding/about-company'
      path: '/onboarding/about-company'
      fullPath: '/onboarding/about-company'
      preLoaderRoute: typeof onboardingAboutCompanyRouteImport
      parentRoute: typeof onboardingLayoutRoute
    }
    '/_onboarding/onboarding/ai-visibility': {
      id: '/_onboarding/onboarding/ai-visibility'
      path: '/onboarding/ai-visibility'
      fullPath: '/onboarding/ai-visibility'
      preLoaderRoute: typeof onboardingAiVisibilityRouteImport
      parentRoute: typeof onboardingLayoutRoute
    }
    '/_onboarding/onboarding/business-dna': {
      id: '/_onboarding/onboarding/business-dna'
      path: '/onboarding/business-dna'
      fullPath: '/onboarding/business-dna'
      preLoaderRoute: typeof onboardingBusinessDnaRouteImport
      parentRoute: typeof onboardingLayoutRoute
    }
    '/_onboarding/onboarding/connect-data': {
      id: '/_onboarding/onboarding/connect-data'
      path: '/onboarding/connect-data'
      fullPath: '/onboarding/connect-data'
      preLoaderRoute: typeof onboardingConnectDataRouteImport
      parentRoute: typeof onboardingLayoutRoute
    }
    '/_onboarding/onboarding/personalization': {
      id: '/_onboarding/onboarding/personalization'
      path: '/onboarding/personalization'
      fullPath: '/onboarding/personalization'
      preLoaderRoute: typeof onboardingPersonalizationRouteImport
      parentRoute: typeof onboardingLayoutRoute
    }
    '/_onboarding/onboarding/referral-code': {
      id: '/_onboarding/onboarding/referral-code'
      path: '/onboarding/referral-code'
      fullPath: '/onboarding/referral-code'
      preLoaderRoute: typeof onboardingReferralCodeRouteImport
      parentRoute: typeof onboardingLayoutRoute
    }
  }
}

interface appSettingsLayoutRouteChildren {
  appSettingsBillingRoute: typeof appSettingsBillingRoute
  appSettingsCreditsRoute: typeof appSettingsCreditsRoute
  appSettingsIntegrationsRoute: typeof appSettingsIntegrationsRoute
  appSettingsSkillsRoute: typeof appSettingsSkillsRoute
  appSettingsUtmRoute: typeof appSettingsUtmRoute
  appSettingsIndexRoute: typeof appSettingsIndexRoute
}

const appSettingsLayoutRouteChildren: appSettingsLayoutRouteChildren = {
  appSettingsBillingRoute: appSettingsBillingRoute,
  appSettingsCreditsRoute: appSettingsCreditsRoute,
  appSettingsIntegrationsRoute: appSettingsIntegrationsRoute,
  appSettingsSkillsRoute: appSettingsSkillsRoute,
  appSettingsUtmRoute: appSettingsUtmRoute,
  appSettingsIndexRoute: appSettingsIndexRoute,
}

const appSettingsLayoutRouteWithChildren =
  appSettingsLayoutRoute._addFileChildren(appSettingsLayoutRouteChildren)

interface appLayoutRouteChildren {
  appExperimentsRoute: typeof appExperimentsRoute
  appKlevRoute: typeof appKlevRoute
  appOverviewRoute: typeof appOverviewRoute
  appReportsRoute: typeof appReportsRoute
  appSalesRoute: typeof appSalesRoute
  appSettingsLayoutRoute: typeof appSettingsLayoutRouteWithChildren
  appAttributionDetailRoute: typeof appAttributionDetailRoute
  appAttributionOrderRoute: typeof appAttributionOrderRoute
  appCreativeCompetitorsRoute: typeof appCreativeCompetitorsRoute
  appAttributionIndexRoute: typeof appAttributionIndexRoute
  appCreativeIndexRoute: typeof appCreativeIndexRoute
}

const appLayoutRouteChildren: appLayoutRouteChildren = {
  appExperimentsRoute: appExperimentsRoute,
  appKlevRoute: appKlevRoute,
  appOverviewRoute: appOverviewRoute,
  appReportsRoute: appReportsRoute,
  appSalesRoute: appSalesRoute,
  appSettingsLayoutRoute: appSettingsLayoutRouteWithChildren,
  appAttributionDetailRoute: appAttributionDetailRoute,
  appAttributionOrderRoute: appAttributionOrderRoute,
  appCreativeCompetitorsRoute: appCreativeCompetitorsRoute,
  appAttributionIndexRoute: appAttributionIndexRoute,
  appCreativeIndexRoute: appCreativeIndexRoute,
}

const appLayoutRouteWithChildren = appLayoutRoute._addFileChildren(
  appLayoutRouteChildren,
)

interface authLayoutRouteChildren {
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
}

const authLayoutRouteChildren: authLayoutRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(
  authLayoutRouteChildren,
)

interface onboardingLayoutRouteChildren {
  onboardingAboutCompanyRoute: typeof onboardingAboutCompanyRoute
  onboardingAiVisibilityRoute: typeof onboardingAiVisibilityRoute
  onboardingBusinessDnaRoute: typeof onboardingBusinessDnaRoute
  onboardingConnectDataRoute: typeof onboardingConnectDataRoute
  onboardingPersonalizationRoute: typeof onboardingPersonalizationRoute
  onboardingReferralCodeRoute: typeof onboardingReferralCodeRoute
}

const onboardingLayoutRouteChildren: onboardingLayoutRouteChildren = {
  onboardingAboutCompanyRoute: onboardingAboutCompanyRoute,
  onboardingAiVisibilityRoute: onboardingAiVisibilityRoute,
  onboardingBusinessDnaRoute: onboardingBusinessDnaRoute,
  onboardingConnectDataRoute: onboardingConnectDataRoute,
  onboardingPersonalizationRoute: onboardingPersonalizationRoute,
  onboardingReferralCodeRoute: onboardingReferralCodeRoute,
}

const onboardingLayoutRouteWithChildren =
  onboardingLayoutRoute._addFileChildren(onboardingLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  homeRoute: homeRoute,
  appLayoutRoute: appLayoutRouteWithChildren,
  authLayoutRoute: authLayoutRouteWithChildren,
  onboardingLayoutRoute: onboardingLayoutRouteWithChildren,
  connectorSetupRoute: connectorSetupRoute,
  onboardingDataLoadingRoute: onboardingDataLoadingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
